<template>
  <ul>
    <draggable
        :list="mutableTreeData"
        :group="{ name: group, pull: pullOption, put: putOption }"
        :clone="clone"
        item-key="_tempKey"
    >
        <template #item="{ element: node }">
            <draggable-tree-node
                :node="node"
                :group="group"
                :node-text-field="nodeTextField"
                :container-text-field="containerTextField"
                :node-id-field="nodeIdField"
                :child-array-name="childArrayName"
                :show-prefix-icon="showPrefixIcon"
                :container-id-field="containerIdField"
                :show-lock-condition="showLockCondition"
                :show-collapse="showCollapse"
                :enable-node-drag-to-root="enableNodeDragToRoot"
                :pull-option="pullOption"
                :put-option="putOption"
                :enable-only-drag-containers="enableOnlyDragContainers"
                @remove-node="removeNode"
                @item-selected="itemSelected"
            />
        </template>
    </draggable>
  </ul>
</template>

<script>
  import draggable from "vuedraggable";
  import baseInputs from '@/components/mixins/BaseInputs';
  import DraggableTreeNode from "./DraggableTreeNode.vue";

  export default {
    name: "p-draggable-tree",
    components: { draggable, DraggableTreeNode },
    mixins: [baseInputs],
    props: {
      // value prop now comes from modelValue via BaseInputs mixin
      containerTextField: String,
      nodeTextField: String,
      nodeIdField: String,
      childArrayName: String,
      clone: Function,
      pullOption: {
        type: [Boolean, String, Function],
        default: true
      },
      putOption: {
        type: [Boolean, Array, Function],
        default: true
      },
      showLockCondition:  [Function, null],        
      containerIdField: {
        type: String,
        default: "id"
      },
      group: {
          type: String,
          default: "items"
      },
      showPrefixIcon: {
        type: Boolean,
        default: true
      },
      showCollapse: {
        type: Boolean,
        default: true
      },
      enableNodeDragToRoot: {
          type: Boolean,
          default: false
      },
      enableOnlyDragContainers: {
          type: Boolean,
          default: false
      }
    },
    computed: {
      value() { return this.modelValue; },
    },
    data() {
      return {
        mutableTreeData: [],
        previousSelectedNode: null,
        tempIdCounter: -1,
        valueIsUpdating: false
      };
    },
    watch: {
        value: {
            handler: function(newVal) {
                if (this.mutableTreeData === newVal) {
                    return;
                }
                this.mutableTreeData = Array.isArray(newVal) ? newVal : [];

                if(this.valueIsUpdating)
                {
                  return;
                }

                this.updateOrder();
            },
            deep: true
        }
    },
    methods: {
      updateOrder() {
        this.valueIsUpdating = true;
        const updateIndex = (list) => {
          if (!Array.isArray(list)) return;
          list.forEach((item, index) => {
            item.displayOrder = index; //maybe make this generic/prop? // like pass in a name for a field to use as index.
            if (item.isContainer && item[this.childArrayName]) {
              updateIndex(item[this.childArrayName]);
            }
          });
        };        
        updateIndex(this.mutableTreeData);
        this.valueIsUpdating = false;
      },
      ensureExpandedProperty(nodes) {
        nodes?.forEach(node => {
          if (!node.hasOwnProperty("expanded")) {
            node.expanded = false;
          }
          if (node.isContainer && !Array.isArray(node[this.childArrayName])) {
            node[this.childArrayName] = [];
          }
          if (node[this.childArrayName]) {
            this.ensureExpandedProperty(node[this.childArrayName]);
          }
          node._tempKey = node[this.nodeIdField] || node[this.containerIdField] || this.generateTempId();
        });
      },
      generateTempId()
      {
        return this.tempIdCounter--;
      },
      removeNode(node){
        const itemIndex = this.mutableTreeData.findIndex(i => i[this.containerIdField] === node[this.containerIdField]);
        if (itemIndex !== -1) {
          this.mutableTreeData.splice(itemIndex, 1);
        }
      },
      itemSelected(node)
      {
        if(this.previousSelectedNode)
        {
          this.previousSelectedNode.isSelected = false;
        }

        this.previousSelectedNode = node;
        node.isSelected = true;
        this.$emit('item-selected', node);
      }
    },
    created() {
      this.mutableTreeData = this.value;
      this.ensureExpandedProperty(this.mutableTreeData);
      this.$emit('update:modelValue', this.mutableTreeData);
      this.$emit('input', this.mutableTreeData);
    }
};
</script>